import { useCallback, useState } from "react";

type UseFileDropOptions = {
  onFileDrop: (file: File) => void;
  accept?: string;
};

export function useFileDrop({ onFileDrop, accept = ".md" }: UseFileDropOptions) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback(() => {
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setIsDragging(false);
      const file = Array.from(e.dataTransfer.files).find((f) =>
        f.name.endsWith(accept),
      );
      if (file) onFileDrop(file);
    },
    [onFileDrop, accept],
  );

  const dropProps = {
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
  };

  return { isDragging, dropProps };
}
